<template>

    <div class="n2-center-container" style="position: relative;">
        <div>
            <a @click="$router.go(-1)" class="n2-link-back">
                <div style="display: flex; align-items:center;">
                    <i aria-hidden="true" class="fa fa-angle-left" style="font-size:2em;"></i>
                    <span style="margin-left:5px;">
                        {{ $t('pages.account.delete_account.back') }}
                    </span>
                </div>
            </a>
        </div>
        <h5 class="n2-text-center">{{ $t('pages.account.delete_account.title') }}</h5>
        <div>
            <div class="n2-text-center">{{ $t('pages.account.delete_account.description') }}</div>
            <div class="n2-margin-top n2-text-center">
                <button class="n2-button-1" v-on:click="deleteAccount()">{{
                    $t('pages.account.delete_account.delete_account') }}</button>
            </div>
            <div class="n2-margin-top">
                <result-summary v-bind:error="result_error"></result-summary>
            </div>
        </div>
        <h5 v-if="result == 'succeeded'">{{ $t('pages.account.delete_account.succeeded') }}</h5>
        <app-loader v-bind:active="loading"></app-loader>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { AccountService, IdentityService } from '../services'
import AppLoader from '../components/shared/loader.vue'
import ResultSummary from '../components/shared/result-summary.vue';


export default {
    components: {
        AppLoader, ResultSummary
    },
    data: function () {
        return {
            model_errors: {},
            model: {},
            customer: {},
            loading: false,
            result: '',
            result_error: ''
        }
    },
    computed: {
        ...mapGetters('identity', [
            'user',
        ]),
        ...mapGetters('globalization', [
            'app_locale',
            'locale'
        ]),
    },

    created: function () {
        this.accountService = new AccountService();
        this.identityService = new IdentityService();
    },
    mounted: async function () {
    },
    methods: {
        deleteAccount: async function () {
            this.result_error = '';
            try {
                this.loading = true;
                await this.accountService.delete();
                try {
                    this.$store.commit('identity/signout')
                    await this.identityService.signout();
                }
                catch {
                    this.model_errors = { sign_in: [this.$t('components.signin.error_sign_out')] }
                }
                this.$router.push({ path: `/${this.app_locale}/account-delete-success` });
            }
            catch (err) {
                this.result_error = this.$t('pages.account.delete_account.failed')
            }
            finally {
                this.loading = false;
            }
        }
    }
}
</script>
